import HTTP from "@/_helpers/http";
import { COUNTRIES__API } from "@/_helpers/urls";
import { COUNTRIES__MUTATIONS } from "../mutation-types";
import { COUNTRIES__ACTIONS } from "../action-types";

// State
const state = {
  countries: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [COUNTRIES__MUTATIONS.COUNTRIES](state, data) {
    state.countries = data;
  },
};
// Actions
const actions = {
  async [COUNTRIES__ACTIONS.COUNTRIES]({ commit, state }) {
    try {
      const response = await HTTP().get(COUNTRIES__API.COUNTRIES);

      if (response.status === 200) {
        commit(COUNTRIES__MUTATIONS.COUNTRIES, response.data);
      } else {
        commit(COUNTRIES__MUTATIONS.COUNTRIES, []);
      }
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
